var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangeB(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 206,
    height: 167,
    fill: "none",
    viewBox: "0 0 206 167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff6f67",
    strokeLinejoin: "round",
    d: "M163.251 183.735c-14.24 5.561-44.299 11.085-71.39 14.203-24.009 2.931-45.952 3.307-54.443-2.668-8.116-5.748-13-26.602-17.021-49.822-1.616-9.356-2.968-19.05-4.584-28.368L4.09 49.335C.596 29.158-2.147 7.93 4.841-.112 19.307-16.907 89.908-35.656 123.01-32.688c25.512 2.104 46.591 16.458 52.64 37.123 5.411 18.599 1.917 41.556-6.725 48.958 14.127 6.237 29.908 23.972 33.891 46.892 6.425 37.047-4.133 69.285-39.527 83.488zM90.659 40.242c5.11-.901 9.957-5.147 8.98-10.858-.15-.902-.6-1.766-1.164-3.232-2.255-3.945-5.9-5.485-9.544-4.847-5.11.902-9.544 5.674-8.642 11.122l.376 2.104c1.803 4.96 6.087 6.388 9.994 5.711Zm17.697 93.446c4.81-.827 9.957-5.148 9.018-10.559-.226-1.202-.676-2.066-1.165-3.193-2.592-4.209-6.5-5.411-10.145-4.772-4.809.826-9.618 5.41-8.642 11.122.113.601.526 1.164.602 1.766 1.84 5.297 6.087 6.387 10.295 5.673z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeB);
export default __webpack_public_path__ + "static/media/orangeB.c24b59dc5c22d7aee962279303962959.svg";
export { ForwardRef as ReactComponent };